import { isSafeReturnTo } from "@/lib/route-paths";

const PENDING_AUTH_REDIRECT_KEY = "cosimo_pending_auth_redirect";

type QueryLike = string | { toString(): string } | null | undefined;

export function sanitizePendingAuthRedirect(path: string | null): string | null {
  return isSafeReturnTo(path) ? path : null;
}

export function buildPathWithQuery(pathname: string, query: QueryLike): string {
  const rawQuery = typeof query === "string" ? query.replace(/^\?/, "") : (query?.toString() ?? "");
  return rawQuery ? `${pathname}?${rawQuery}` : pathname;
}

export function setPendingAuthRedirect(path: string | null): void {
  if (typeof window === "undefined") return;

  const safePath = sanitizePendingAuthRedirect(path);
  if (safePath) {
    window.sessionStorage.setItem(PENDING_AUTH_REDIRECT_KEY, safePath);
    return;
  }

  window.sessionStorage.removeItem(PENDING_AUTH_REDIRECT_KEY);
}

export function peekPendingAuthRedirect(): string | null {
  if (typeof window === "undefined") return null;

  const pendingPath = window.sessionStorage.getItem(PENDING_AUTH_REDIRECT_KEY);
  const safePath = sanitizePendingAuthRedirect(pendingPath);

  if (!safePath && pendingPath) {
    window.sessionStorage.removeItem(PENDING_AUTH_REDIRECT_KEY);
  }

  return safePath;
}

export function consumePendingAuthRedirect(): string | null {
  const pendingPath = peekPendingAuthRedirect();

  if (typeof window !== "undefined") {
    window.sessionStorage.removeItem(PENDING_AUTH_REDIRECT_KEY);
  }

  return pendingPath;
}
